import { css } from "lit-element";

//language=CSS
export const style = css`
	:host {
		padding-left: 40px;
        margin-left: 20px;
		border-left: 1px solid var(--app-lightgrey);
	}
	.user-menu-button {
		position: relative;
		line-height: 40px;
		padding: 0 20px;
		cursor: pointer;
	}

	a {
		color: var(--app-primary);
		text-decoration: none;
		font-weight: bold;
	}

	user-circle-image {
        margin: 0;
        padding: 0;
	}

	.user-menu-button[selected] {
		color: #ffffff;
		background-color: var(--app-accent);
	}

	.user-menu-button[selected] span,
	.user-menu-button[selected] p {
		color: #ffffff;
	}

	.user-menu-button[selected] user-circle {
		color: var(--app-accent);
		background-color: #ffffff;
	}
`;
